import { api } from './client';

export interface AdminPhotoCleanupRequest {
  execute?: boolean;
  removeInactiveGalleryPhotos?: boolean;
  removeBlacklistedPhotos?: boolean;
}

export interface AdminPhotoCleanupResponse {
  execute: boolean;
  removeInactiveGalleryPhotos: boolean;
  removeBlacklistedPhotos: boolean;
  totalModels: number;
  blacklistedModels: number;
  blacklistedCreatorPageModels: number;
  blacklistedNonCreatorModels: number;
  blacklistedCurrentImages: number;
  inactiveGalleryRows: number;
  blacklistedGalleryRows: number;
  currentPhotoRefsBefore: number;
  currentPhotoRefsAfter: number;
  currentPhotoRefsToClear: number;
  galleryPhotoRowsBefore: number;
  galleryPhotoRowsAfter: number;
  galleryPhotoRowsToRemove: number;
  photoRefsBefore: number;
  photoRefsAfter: number;
  objectKeysToDeleteCount: number;
  modelImagesCleared: number;
  galleryRowsRemoved: number;
  objectKeysToDelete: string[];
  objectsDeleted: number;
  objectDeleteFailures: string[];
}

export interface AdminPhotoCleanupJobStatus {
  jobId: string | null;
  state: 'IDLE' | 'RUNNING' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED' | string;
  running: boolean;
  startedAt: string | null;
  finishedAt: string | null;
  error: string | null;
  totalModels: number;
  totalObjects: number;
  objectsDeleted: number;
  objectsFailed: number;
  blacklistedModels: number;
  blacklistedCreatorPageModels: number;
  blacklistedNonCreatorModels: number;
  blacklistedCurrentImages: number;
  inactiveGalleryRows: number;
  blacklistedGalleryRows: number;
  currentPhotoRefsBefore: number;
  currentPhotoRefsAfter: number;
  currentPhotoRefsToClear: number;
  galleryPhotoRowsBefore: number;
  galleryPhotoRowsAfter: number;
  galleryPhotoRowsToRemove: number;
  photoRefsBefore: number;
  photoRefsAfter: number;
  modelImagesCleared: number;
  galleryRowsRemoved: number;
  recentFailures: string[];
}

const defaultCleanupOptions = {
  removeInactiveGalleryPhotos: true,
  removeBlacklistedPhotos: true
};

export const dryRunPhotoCleanup = async (
  request: AdminPhotoCleanupRequest = {}
): Promise<AdminPhotoCleanupResponse> => {
  const { data } = await api.post<AdminPhotoCleanupResponse>('/admin/photo-cleanup', {
    ...defaultCleanupOptions,
    ...request,
    execute: false
  });
  return data;
};

export const startPhotoCleanup = async (
  request: AdminPhotoCleanupRequest = {}
): Promise<AdminPhotoCleanupJobStatus> => {
  const { data } = await api.post<AdminPhotoCleanupJobStatus>('/admin/photo-cleanup/start', {
    ...defaultCleanupOptions,
    ...request,
    execute: true
  });
  return data;
};

export const getPhotoCleanupStatus = async (): Promise<AdminPhotoCleanupJobStatus> => {
  const { data } = await api.get<AdminPhotoCleanupJobStatus>('/admin/photo-cleanup/status');
  return data;
};
